import ServicoFab from './ServicoFab';

export default ServicoFab;
